import type { ComponentProps } from 'react';
import { msg } from '@gonfalon/messages/msg';
import { useMember } from '@gonfalon/rest-api/hooks/useMember';
import { Tag, TagAvatar, TagFallback } from '@gonfalon/ui/TagGroup';
import { TextTruncator } from '@gonfalon/ui/TextTruncator';

import { MemberAvatar } from './MemberAvatar';
import { memberDisplayName } from './memberDisplayName';
import { memberInitials } from './memberInitials';

type TagProps = ComponentProps<typeof Tag>;

export function MemberMaintainerTag({ maintainerId, ...tagProps }: { maintainerId: string } & TagProps) {
  const { data: member, isLoading } = useMember({ memberId: maintainerId });

  if (isLoading) {
    return (
      <TagFallback aria-label={msg('members.maintainerTag.loadingLabel', { maintainerId })} {...tagProps}>
        <TagFallback.Visual />
        <TagFallback.Text />
      </TagFallback>
    );
  }

  if (!member) {
    return null;
  }

  return (
    <Tag
      aria-label={memberDisplayName(member)}
      {...tagProps} // Forward RAC identity props (id, textValue) and other props
    >
      <TagAvatar>
        <MemberAvatar size="small" email={member.email} initials={memberInitials(member)} />
      </TagAvatar>{' '}
      <TextTruncator>{memberDisplayName(member)}</TextTruncator>
    </Tag>
  );
}
